import { render, staticRenderFns } from "./TeamChatAccordion.vue?vue&type=template&id=4e9abc20"
import script from "./TeamChatAccordion.vue?vue&type=script&lang=js"
export * from "./TeamChatAccordion.vue?vue&type=script&lang=js"
import style0 from "./TeamChatAccordion.vue?vue&type=style&index=0&id=4e9abc20&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports